// FastAPI validation errors (e.g. an invalid EmailStr) return `detail` as an array
// of error objects rather than a string - render that raw and React throws
// "Objects are not valid as a React child", blanking the whole page.
export const getErrorMessage = (error: any, fallback: string): string => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d: any) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean).join('; ') || fallback;
  }
  if (detail && typeof detail === 'object' && typeof detail.msg === 'string') return detail.msg;
  return error?.message || fallback;
};
